/**
 * Lo que devuelve la API, con sus nombres.
 *
 * No se renombra nada al pasar por acá: el día que alguien busque `estado_raw` para entender de
 * dónde sale el cartel de "SIN STOCK", quiere encontrarlo escrito igual en las dos puntas.
 */

export interface Producto {
  id: string;
  code: string;
  description: string;
  category: string | null;
  price: number | null;
  bulk: string | null;
  cut: string | null;
  discount: string | null;
  bulk_discount: string | null;
  estado_raw: string | null;

  /**
   * Las etiquetas ya calculadas a partir de `estado_raw`.
   *
   * Las calcula el servidor al leer la planilla, y no el navegador. Que las reglas ("OFERTA",
   * "SIN STOCK", "REPOSICIÓN"…) vivan en un solo lado es lo que evita que la ficha diga una
   * cosa y el filtro del catálogo otra.
   */
  is_offer: boolean;
  is_reposition: boolean;
  is_no_discount: boolean;
  is_in_stock: boolean;
  is_incoming: boolean;

  brand: string | null;
  display_order: number;

  /**
   * Si el producto tiene al menos una foto cargada.
   *
   * Lo manda sólo el listado del panel, que es donde está el filtro por foto; el catálogo
   * público no lo incluye y por eso es opcional.
   */
  has_image?: boolean;
}

export interface Imagen {
  id: string;
  name: string;
  file_name: string;
  url: string;
  thumbnail_url: string | null;
  size: number;
  category: string;
  is_active: boolean;
  alt_text: string | null;
  link_url: string | null;
  link_target: string;
  display_order: number;
  product_code: string | null;
  created_at: string;
  updated_at: string;
}

/** Quién está mirando el sitio. `null` es el caso normal: una visita anónima. */
export interface Sesion {
  id: string;
  username: string | null;
  email: string;
  role: 'superadmin' | 'admin' | 'usuario';
  account_status: 'active' | 'inactive' | 'suspended';

  /**
   * La contraseña la puso otra persona y hay que cambiarla antes de seguir.
   *
   * Es el primer ingreso de una cuenta recién creada: esa contraseña la conoce alguien más.
   */
  requires_password_change: boolean;
}

/** Quién puede entrar al panel. Un usuario común no. */
export function esDelEquipo(sesion: Sesion | null): boolean {
  return sesion?.role === 'admin' || sesion?.role === 'superadmin';
}

export interface Paginacion {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}
